import { useState, useCallback, useEffect } from 'react';
import  _  from 'lodash';


export default function useLocalStorage(key = 'movies', initialValue = []) {

  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });

  const setValue = value => {
    try {
      setStoredValue(value);
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.log(error);
    }
  };

  const removeValue = value => {
    try {
      let shallowCopy = [...storedValue];
      let indexToRemove = shallowCopy.findIndex((x) => x.id === value );
      shallowCopy.splice(indexToRemove, 1) 
      setStoredValue(shallowCopy);
      window.localStorage.setItem(key, JSON.stringify(shallowCopy));
    } catch (error) {
      console.log(error);
    }
  };

  const itemExistToStorage = (value) => {
    try {
      if(_.find(storedValue, ['id', value])) { 
        return true;
      } else {
        return false;
      }
    } catch(error) {
      console.log(error);
    }
  };


  return [storedValue, setValue, removeValue, itemExistToStorage];
}